import { render, staticRenderFns } from "./CatalogListFavorites.vue?vue&type=template&id=daa9841a"
import script from "./CatalogListFavorites.vue?vue&type=script&lang=js"
export * from "./CatalogListFavorites.vue?vue&type=script&lang=js"
import style0 from "./CatalogListFavorites.vue?vue&type=style&index=0&id=daa9841a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports